$(function() {
  const hasForm = $('.js-payment-page').length > 0;
  if (!hasForm) { return; }

  if (window.join == null) { window.join = {}; }

  // summary display elements
  const summaryAmount = $('.js-summary-amount');
  const summaryTotal = $('.js-summary-total');
  const summaryFrequency = $('.js-summary-frequency');
  const summarySubscriptionType = $('.js-summary-subscription-type');
  const summaryPromoDiscount = $('.js-summary-discount');
  const summaryPromoDiscountRow = $('.js-summary-discount-row');

  // applying promo code
  const promoCodeInput = $('#promo-code');
  const promoCodeInputIcon = $('.summary-input');
  const promoCodeApplyButton = $('.js-apply-promo');
  const promoCodeMessage = $('.js-promo-message');

  // form fields
  const membershipProductId = $('#membership-form-membership-product-id');
  const membershipReceivesMagazine = $('#membership-form-receives-magazine');
  const promoCodeId = $('#membership-form-promo-code-id');
  const promoCodeDiscount = $('#membership-form-promo-discount');

  const formatPrice = price => {
    return '$' + parseFloat(price).toFixed(2).toString().replace(/\.00$/,'');
  };

  const hasSelection = () => {
    if ($('.js-membership-product-radio:checked').length > 0) { return true; }
    if ($('.js-membership-options-option-active button').data('digital-pass')) { return true; }
    return false;
  };

  const getProductSelection = () => {
    if ($('.js-membership-product-radio:checked').length > 0) {
      return $('.js-membership-product-radio:checked').data('membership-product-id');
    }
    if ($('.js-membership-options-option-active button').data('digital-pass')) {
      return $('.js-membership-options-option-active button').data('membership-product-id');
    }
    return '';
  };

  const selectedAllowsMag = () => {
    return $('.js-membership-product-radio:checked').data('allows-magazine') === true;
  };

  const isAlt = () => {
    return $('#alt-join-form').length > 0;
  };

  const digitalPassSelected = () => {
    if ($('.js-membership-options-option-active button').data('digital-pass')) {
      return $('.js-membership-options-option-active button').data('membership-product-id');
    }
    if ($('.js-membership-product-radio[data-digital-pass]:checked').length > 0) {
      return $('.js-membership-product-radio:checked').data('membership-product-id');
    }
    return false;
  };

  const updateHiddenMembershipFields = () => {
    let productType;
    if (hasSelection()) {
      membershipProductId.val(getProductSelection());
    }
    if (isAlt()) {
      const magazine = $('#member_include_magazine').prop('checked');
      productType = magazine === true ? 'online_and_magazine' : 'online';
    } else {
      const selectedOpt = $('.js-membership-options-option-active');
      if (selectedOpt.length <= 0) { return; }
      productType = selectedOpt.find('.js-membership-option-select').data('product-type');
    }

    if (productType === 'online_and_magazine') {
      membershipReceivesMagazine.val('true');
    } else {
      // Inlcudes both digital_pass flagged and online options..
      membershipReceivesMagazine.val('false');
    }
  };

  const showDigitalTerms = () => {
    if (digitalPassSelected()) {
      $('.js-digital-option').show();
      $('.js-membership-form-digital-terms').show();
    } else {
      $('.js-membership-form-digital-terms').hide();
    }
  };

  const updateSummary = () => {
    let product;
    let digital = false;
    let magazine = membershipReceivesMagazine.val();

    // Try for a digital pass product...
    if (digitalPassSelected()) {
      // Show the terms...
      if (isAlt()) {
        product =  $('.js-membership-product-radio:checked');
      } else {
        product = $('.js-membership-options-option-active button');
      }

      digital = 'true';
      magazine = false;
    } else {
      product = $('.js-membership-product-radio:checked');
    }

    if (product.length > 0) {
      let rawAmount;
      const frequency = product.data('membership-product-term');
      summaryFrequency.text(frequency);

      if (isAlt() && (magazine === 'true')) {
        rawAmount = product.data('membership-magazine-toggled-amount') || 0.00;
      } else {
        rawAmount = product.data('membership-product-amount') || 0.00;
      }

      summaryAmount.text(formatPrice(rawAmount));
      summaryTotal.text(formatPrice(rawAmount));
      $('input[type="submit"]').prop('disabled', false);
    } else {
      summaryFrequency.text('-');
      summaryAmount.text('-');
      summaryTotal.text('-');
      $('input[type="submit"]').prop('disabled', true);
    }

    $('.js-membership-online-icon').hide();
    $('.js-membership-digital-icon').hide();
    $('.js-membership-magazine-online-icon').hide();

    if (magazine === 'true') {
      $('.js-membership-magazine-online-icon').show();
      summarySubscriptionType.text('Online + Magazine Membership');
    } else if (digital === 'true') {
      $('.js-membership-digital-icon').show();
      summarySubscriptionType.text('Digital Pass');
    } else {
      $('.js-membership-online-icon').show();
      summarySubscriptionType.text('Online Membership');
    }


    if (isAlt()) {
      // Show / hide the magazine toggle for alt...
      if (hasSelection()) {
        const magazineprice = product.data('membership-product-magazine-price');
        $('span.addon-when-priced').show();
        $('span.addon-in-price').text(formatPrice(magazineprice));
      } else {
        $('span.addon-when-priced').hide();
      }
    }
  };

  const enableProductSelection = () => {
    let productType;
    $('.js-payment-page-form').show();

    if (isAlt()) {
      const magazine = $('#member_include_magazine').prop('checked');
      productType = magazine === true ? 'online_and_magazine' : 'online';
      $('.js-membership-product-options').show();
      $(`.js-membership-product-options-label[data-product-type='${productType}']`).css({'display':'block'});
    } else {
      const selectedOpt = $('.js-membership-options-option-active');
      if (selectedOpt.length <= 0) { return; }
      $('.js-membership-product-options').show();

      productType = selectedOpt.find('.js-membership-option-select').data('product-type');
      $('.js-option-online').hide();
      $('.js-option-online-mag').hide();
      $('.js-digital-option').hide();

      if (productType === 'online') {
        $('.js-purchase-label-magazine').addClass('js-dn');
        $('.js-purchase-label').removeClass('js-dn');
        $('.js-membership-payment-subscription').text('Select your Payment Frequency');
        $('.js-option-online').show();
      } else {
        $('.js-option-online-mag').show();
        $('.js-purchase-label').addClass('js-dn');
        $('.js-purchase-label-magazine').removeClass('js-dn');
        $('.js-membership-payment-subscription').text('Select your Payment Frequency');
      }

      updateTermsDetails(productType);
    }
  };

  var updateTermsDetails = () => {
    $('[data-temp]').remove();
    let count = 1;
    const seen = {}; // for double ups in layout B
    $('span:visible > [data-terms-details]').each((index, element) => {
      if (!seen.hasOwnProperty($(element).data('terms-details'))) {
        seen[$(element).data('terms-details')] = true;
        $(element).append('<sup data-temp>' + "*".repeat(count) + '</sup>');
        $('.js-details-container').append(
            '<p data-temp><sup>' + "*".repeat(count) + '</sup> ' +   $(element).data('terms-details') + '</p>'
        );
        count += 1;
      }
    });
  };

  const skipProductSelection = () => {
    $('.js-payment-page-form').show();
    $('.js-membership-product-options').hide();
  };

  const resetProductSelection = () => {
    let productType;
    if (isAlt()) {
      // Always show the online ones...
      $(".js-membership-product-options-label[data-product-type=online]").css({'display':'block'});
    } else {
      // Show the right set based on magazine option, IF there is a magazine selection
      const selectedOpt = $('.js-membership-options-option-active');
      if (selectedOpt.length <= 0) { return; }
      productType = selectedOpt.find('.js-membership-option-select').data('product-type');
      if (!productType) { return; }
      $(".js-membership-product-options-label").hide();
      $(`.js-membership-product-options-label[data-product-type='${productType}']`).css({'display':'block'});

      // Update text later in the form
      if (productType === 'online') {
        $('.js-membership-payment-subscription').text('Select your Payment Frequency');
      } else {
        $('.js-membership-payment-subscription').text('Select your Payment Frequency');
      }
    }

    // Update selection if possible
    $(".js-membership-product-radio").prop('checked', false);
    const id = getProductSelection();
    if ($(`#membership_product_id-${id}_${productType}`).not(':disabled').length > 0) {
      $(`#membership_product_id-${id}_${productType}`).prop('checked', true);
    }
  };

  const enableMemberForm = () => {
    if (!hasSelection()) { return; }
    if (isAlt()) {
      $('.membership-form').show();
      $('html').trigger('join.form.ready');
    } else {
      $('.js-payment-page-form').show();
      $('.js-membership-form').show();
      $('html').trigger('join.form.ready');
    }
  };
  // Watched by the validation code

  const setContactVisibility = () => {
    if (!hasSelection() && !isAlt()) { return; }
    const requiresContact = !!$('.js-membership-product-radio:checked + .js-membership-product-options-label')
    .data('requires-contact-number');

    if (requiresContact) {
      $('#member_member_attributes_contact_number').removeAttr('disabled');
      $('label[for=member_member_attributes_contact_number], #member_member_attributes_contact_number').show();
    } else {
      $('#member_member_attributes_contact_number').attr('disabled', 'disabled');
      $('label[for=member_member_attributes_contact_number], #member_member_attributes_contact_number').hide();
    }
  };

  const setAddressVisibility = () => {
    if (!hasSelection() && !isAlt()) { return; }
    let requiresAddress = false;

    if (isAlt()) {
      requiresAddress = $('#member_include_magazine').prop('checked');
      $('.af_list').addClass('af-alt-join');
    } else {
      requiresAddress = $('.js-membership-product-radio:checked')
      .data('product-type') === 'online_and_magazine';
      $('.af_list').addClass('af-join');
    }

    if (requiresAddress) {
      $('.js-address-form').show();
    } else {
      $('.js-address-form').hide();
    }
  };

  const setMagazineOptVisibility = () => {
    if (!isAlt()) { return; }

    if (hasSelection() && selectedAllowsMag()) {
      $('.payment-opt-mag').show();
    } else {
      $('.payment-opt-mag').hide();
      $('#member_include_magazine').prop('checked', false);
    }
  };

  const paintOptionSelected = opt => {
    $('.js-membership-options-option')
    .removeClass('js-membership-options-option-active');
    $(opt).closest('.js-membership-options-option')
    .addClass('js-membership-options-option-active');
  };

  const addMobileClassesForOptionsAfterForm = opt => {
    const productType = $(opt).data('product-type');

    // Paint the other instance of this option, either at the top or the bottom...
    $(`.js-membership-options-option[data-product-type="${productType}"]`)
    .addClass('js-membership-options-option-active');

    // scroll to top of form when selecting option from below summary
    let offsetElm = $('.payment-page-content');
    let offset = offsetElm.offset().top;
    $(window).scrollTop(offset + offsetElm.height());
  };

  const clearPromoData = (clearInput = false) => {
    promoCodeId.val('');
    promoCodeDiscount.val('');
    summaryPromoDiscountRow.hide();
    summaryPromoDiscount.text('');
    summaryTotal.text(summaryAmount.text());
    promoCodeApplyButton.text('Apply');

    promoCodeMessage.hide();
    promoCodeMessage.text('');
    promoCodeMessage.removeClass('summary-valid');
    promoCodeMessage.removeClass('summary-error');

    promoCodeInput.prop('readonly', false);
    promoCodeInput.removeClass('valid');
    promoCodeInput.removeClass('error');
    promoCodeInput.removeClass('loading');

    promoCodeInputIcon.removeClass('valid');
    promoCodeInputIcon.removeClass('loading');
    promoCodeInputIcon.removeClass('filled');

    promoCodeApplyButton.removeClass('disabled');
    $('#membership-form-promo-code-id-error').hide();

    if (clearInput) {
      promoCodeInput.val('');
      promoInputChanged();
    }

    if (promoCodeInput.val().length > 0) { promoCodeInputIcon.addClass('filled'); }
  };

  const validPromoCode = response => {
    const message = response.success_message;
    const { discount_price, total_price, promo_code } = response;

    promoCodeId.val(promo_code);
    promoCodeDiscount.val(discount_price);
    summaryTotal.text(formatPrice(total_price / 100));
    promoCodeApplyButton.text('Remove');

    summaryPromoDiscountRow.show();
    summaryPromoDiscount.text('-' + formatPrice(discount_price / 100));

    promoCodeMessage.text(message);
    promoCodeMessage.addClass('summary-valid');
    promoCodeMessage.show();

    promoCodeInput.prop('readonly', true);
    promoCodeInput.addClass('valid');
    promoCodeInputIcon.addClass('valid');
  };

  const invalidPromoCode = function(response) {
    promoCodeInput.addClass('error');
    if (!$.isEmptyObject(response)) {
      promoCodeMessage.text(response.error_message);
      promoCodeMessage.addClass('summary-error');
      promoCodeMessage.show();
    }
  };

  const applyPromoCode = () => {
    const code = promoCodeInput.val();
    const product = membershipProductId.val();
    const magazine = membershipReceivesMagazine.val();

    $.ajax({
      type: 'GET',
      url: promoCodeApplyButton.data('promoUrl'),
      data: {
        promo_code: code,
        membership_product: product,
        has_magazine: magazine
      },
      success(response) {
        clearPromoData();
        if (response.valid_promo) {
          validPromoCode(response);
        } else {
          invalidPromoCode(response);
        }
      },
      error(e) {
        clearPromoData(true);
        console.log(e);
      }
    });
  };

  const updatePromoDetails = function() {
    if (promoCodeId.val().length > 0) {
      applyPromoCode();
    } else {
      clearPromoData();
    }
  };

  var promoInputChanged = function() {
    $('#membership-form-promo-code-id-error').hide();
    promoCodeMessage.hide();
    promoCodeInput.removeClass('valid');
    promoCodeInput.removeClass('error');
    if (promoCodeInput.val().length > 0) {
      promoCodeApplyButton.removeClass('disabled');
      promoCodeInputIcon.addClass('filled');
    } else {
      promoCodeApplyButton.addClass('disabled');
      promoCodeInputIcon.removeClass('filled');
    }
  };

  const setBelowSummaryOptions = function() {
    $('.js-primary-option-set').appendTo('.js-options-below-summary');

    const selectedOpt = $('.js-membership-options-option-active');
    if (selectedOpt.length <= 0) { return; }
    const productType = selectedOpt.find('.js-membership-option-select').data('product-type');

    const belowSummaryOptions = $('.js-options-below-summary');
    const onlineOpt = belowSummaryOptions.find('div > [data-product-type="online"]');
    const magOpt = belowSummaryOptions.find('div > [data-product-type="online_and_magazine"]');
    const digitalOpt = belowSummaryOptions.find('div > [data-product-type="digital"]');

    onlineOpt.show();
    magOpt.show();
    digitalOpt.show();

    if (productType === "online") {
      onlineOpt.hide();
    } else if (productType === "online_and_magazine") {
      magOpt.hide();
    } else {
      digitalOpt.hide();
    }
  };

  const setupBasedOnHiddenParams  = () => {
    if (!!membershipProductId.val()) {
      let selectedProduct;
      const productId = membershipProductId.val();
      const magazine =  membershipReceivesMagazine.val();
      const productType = magazine === 'true' ? 'online_and_magazine' : 'online';

      // Digital pass...
      if ($('[data-digital-pass]').data('membership-product-id') === parseInt(productId)) {
        if (!isAlt()) {
          paintOptionSelected($('.js-membership-option-select[data-digital-pass]'));
          addMobileClassesForOptionsAfterForm(this);
          skipProductSelection();
        } else {
          $(".js-membership-product-options-label").hide();
          $(".js-membership-product-options-label[data-product-type=online]").show();
          selectedProduct = $(`#membership_product_id-${productId}_online`);
          selectedProduct.attr('checked', 'checked');
        }
      } else {
        // Regular product...
        if (isAlt()) {
          if (magazine === "true") {
            $('#member_include_magazine').prop('checked', 'checked');
          }
        } else {
          $(`[data-product-type='${productType}']`).closest('.js-membership-options-option')
          .addClass('js-membership-options-option-active');
        }

        // Show the right set...
        if (isAlt()) {
          $(".js-membership-product-options-label").hide();
          $(".js-membership-product-options-label[data-product-type='online']").show();
          selectedProduct = $(`#membership_product_id-${productId}_online`);
          selectedProduct.attr('checked', 'checked');
        } else {
          $(".js-membership-product-options-label").hide();
          $(`.js-membership-product-options-label[data-product-type='${productType}']`).css({'display': 'block'});
          selectedProduct = $(`#membership_product_id-${productId}_${productType}`);
          selectedProduct.attr('checked', 'checked');
          enableProductSelection();
        }
      }

      enableMemberForm();
      setContactVisibility();
      setAddressVisibility();
      setMagazineOptVisibility();
      updateSummary();
      showDigitalTerms();
      updatePromoDetails();
      setBelowSummaryOptions();
      if ((promoCodeInput.val().length > 0) && (promoCodeId.val().length === 0)) {
        invalidPromoCode();
      }
    } else {
      // Even if there isn't any params we still enable
      // form components for the alt...
      if (isAlt()) {
        enableMemberForm();
        enableProductSelection();
        resetProductSelection();
        setContactVisibility();
        setAddressVisibility();
        updateSummary();
        setMagazineOptVisibility();
        updatePromoDetails();
      }
    }
  };

  setupBasedOnHiddenParams();

  if (isAlt()) {
    $('input#member_include_magazine').on('change', function() {
      setContactVisibility();
      setAddressVisibility();
      updateHiddenMembershipFields();
      updateSummary();
      updatePromoDetails();
    });
  }

  $('.js-membership-option-select').on('click', function() {
    if (isAlt()) { return; }
    paintOptionSelected(this);
    addMobileClassesForOptionsAfterForm(this);
    resetProductSelection();
    enableProductSelection();
    setContactVisibility();
    setAddressVisibility();
    updateHiddenMembershipFields();
    updateSummary();
    showDigitalTerms();
    updatePromoDetails();
    setBelowSummaryOptions();
  });

  // For the big non-alt digital pass option.
  if (!isAlt()) {
    $('[data-digital-pass]').on('click', function() {
      paintOptionSelected(this);
      addMobileClassesForOptionsAfterForm(this);
      resetProductSelection();
      skipProductSelection();
      enableMemberForm();
      setContactVisibility();
      setAddressVisibility();
      updateHiddenMembershipFields();
      updateSummary();
      showDigitalTerms();
      updatePromoDetails();
    });
  }

  $('.js-membership-product-radio').on('click', function() {
    if (isAlt()) {
      setMagazineOptVisibility();
    }
    enableMemberForm();
    setContactVisibility();
    setAddressVisibility();
    updateHiddenMembershipFields();
    updateSummary();
    showDigitalTerms();
    updatePromoDetails();
  });

  // change things after default jquery validate behaviour
  promoCodeInput.on('keyup', () => promoInputChanged());

  promoCodeInput.on('keydown', function(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      if (promoCodeApplyButton.text() === 'Apply') { promoCodeApplyButton.trigger("click"); }
    }
  });

  promoCodeInput.on('blur', function() {
    if ((promoCodeInput.hasClass('error') && promoCodeInput.hasClass('valid')) || (promoCodeApplyButton.text() === "Apply")) {
      promoCodeInput.removeClass('valid');
    }
  });

  promoCodeInputIcon.on('click', function() {
    if (promoCodeInputIcon.hasClass('filled')) {
      clearPromoData(true);
    }
  });


  promoCodeApplyButton.on('click', function() {
    promoCodeInputIcon.removeClass('filled');
    if ($(this).text() === 'Apply') {
      if (!$(this).hasClass('disabled')) {
        promoCodeInput.addClass('loading');
        promoCodeInputIcon.addClass('loading');
        setTimeout((() => applyPromoCode()), 1500);
      }
    } else {
      clearPromoData(true);
    }
  });

  window.join.promoCodeValidationFailed = function() {
    clearPromoData();
    invalidPromoCode();
  };
});
